exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DatePick__root,\n.DS__DatePick__picker,\n.DS__DatePick__picker-body,\n.DS__DatePick__datepicker-override,\n.DS__DatePick__control {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__DatePick__root {\n  position: relative;\n}\n\n.DS__DatePick__picker {\n  display: none;\n}\n\n.DS__DatePick__picker.DS__DatePick__opened {\n    display: block;\n  }\n\n.DS__DatePick__picker-body {\n  position: absolute;\n  top: 25px;\n  z-index: 10;\n  width: 100%;\n  padding: 16px 0;\n  background: #ffffff;\n  border: 1px solid #d0d6e1;\n  border-radius: 0px 0px 8px 8px;\n  box-shadow: 0 8px 16px -4px rgba(34, 42, 55, 0.13);\n}\n\n.DS__DatePick__picker-body .DS__DatePick__picker-item {\n    padding: 0 16px;\n  }\n\n.DS__DatePick__datepicker-override {\n  padding: 16px 0;\n}\n\n.DS__DatePick__control {\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__DatePick__root",
	"picker": "DS__DatePick__picker",
	"picker-body": "DS__DatePick__picker-body",
	"datepicker-override": "DS__DatePick__datepicker-override",
	"control": "DS__DatePick__control",
	"opened": "DS__DatePick__opened",
	"picker-item": "DS__DatePick__picker-item"
};